import { Member } from '@tribeplatform/gql-client/types'

export const MemberBannerPlaceholder = ({
  member,
  placeholderBanners: banners,
}: {
  member: Member
  placeholderBanners: string[]
}) => {
  if (!banners || banners.length === 0) {
    return null
  }

  let index = 0
  if (member?.id) {
    index = member?.id?.charCodeAt(member?.id?.length - 1) % banners.length
  }
  return <img src={banners[index]} alt={member?.name} />
}
